const parseQueryStrings = (queryString) => {
  const array = queryString.slice(1).split('&')
  return array.map(q => {const a = q.split('='); return {[a[0]]: a[1]}})
}

const getCurrentStoreId = (queryParams) => {
  return  queryParams.find(e => Object.keys(e)[0] === 'currentStoreId')?.currentStoreId
}

export {parseQueryStrings, getCurrentStoreId}